// Shared pipeline stage configuration used across the app

export const pipelineStages = [
  'applied',
  'ai_reviewed',
  'shortlisted',
  'interviewed',
  'second_interview',
  'offering',
  'signing_contract',
  'hired',
] as const;

export type PipelineStage = (typeof pipelineStages)[number];

export const stageLabels: Record<string, string> = {
  applied: 'Applied',
  ai_reviewed: 'AI Reviewed',
  shortlisted: 'Shortlisted',
  interviewed: 'Interviewed',
  second_interview: 'F2F Interview',
  offering: 'Offering',
  signing_contract: 'Signing Contract',
  hired: 'Hired',
  // Non-pipeline statuses
  offer_stage: 'Offer Stage',
  rejected: 'Rejected',
  low_match: 'Low Match',
  withdrawn: 'Withdrawn',
  on_hold: 'On Hold',
  archived: 'Archived',
  // Job statuses
  draft: 'Draft',
  active: 'Active',
  inactive: 'Inactive',
  closed: 'Closed',
  expired: 'Expired',
};

export const stageStyles: Record<string, string> = {
  applied: 'bg-foreground/10 text-foreground',
  ai_reviewed: 'bg-foreground/10 text-foreground',
  shortlisted: 'bg-foreground/10 text-foreground',
  interviewed: 'bg-foreground/10 text-foreground',
  second_interview: 'bg-foreground/10 text-foreground',
  offering: 'bg-foreground/10 text-foreground',
  signing_contract: 'bg-foreground/10 text-foreground',
  hired: 'bg-foreground/10 text-foreground',
  // Non-pipeline statuses
  offer_stage: 'bg-success/10 text-success',
  rejected: 'bg-destructive/10 text-destructive',
  low_match: 'bg-muted text-muted-foreground',
  withdrawn: 'bg-muted text-muted-foreground',
  on_hold: 'bg-warning/10 text-warning',
  archived: 'bg-muted text-muted-foreground',
  // Job statuses
  draft: 'bg-muted text-muted-foreground',
  active: 'bg-success/10 text-success',
  inactive: 'bg-warning/10 text-warning',
  closed: 'bg-muted text-muted-foreground',
  expired: 'bg-destructive/10 text-destructive',
};
